var exports = {
  "Q": "BrowserLoginHandoffModal.module__content___LXJPeX",
  "A": "BrowserLoginHandoffModal.module__prefillHint___LXJPeX",
};

module.exports = exports;
